<template>
  <portlet
      :icon="'fal fa-edit'"
      :title="'Kandidaat plaatsen'"
      :actionsBlock="true"
      :footer="true"
  >
    <template slot="portletBody">
      <template v-if="!isAdmin">
        <div class="alert alert-info">Plaatsingen mogen alleen door een beheerder worden aangemaakt.</div>
      </template>
      <template v-else-if="!candidate.blacklisted">
        <div v-if="!hasContract" class="alert alert-danger">
          <i class="fal fa-exclamation-triangle mr-2"></i>
          Er is geen contract gevonden voor deze kandidaat. Een plaatsing kan alleen worden aangemaakt als er een contract aanwezig is.
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidatePlacement-customer">Bedrijf</label>
            <v-select
                :options="getCustomers"
                :selectOnTab="true"
                id="candidatePlacement-customer"
                label="name"
                name="customer"
                v-validate="'required'"
                v-model="candidatePlacement.customerId"
                :reduce="getCustomers => getCustomers.id"
                :class="{ 'is-invalid': errors.has('customer')}"
                :clearable="false"
                @input="customerChosen($event)"
            >
              <div slot="no-options">Geen bedrijven gevonden</div>
            </v-select>
            <span v-if="errors.first('customer')" class="small text-danger">Dit veld is verplicht</span>
          </div>
<!--          <div class="form-group col-lg-5">-->
<!--            <label for="candidatePlacement-vacancy">Vacature</label>-->
<!--            <v-select-->
<!--                :options="getVacanciesFromCustomer(candidatePlacement.customerId)"-->
<!--                :selectOnTab="true"-->
<!--                id="candidatePlacement-vacancy"-->
<!--                label="name"-->
<!--                v-model="candidatePlacement.vacancyId"-->
<!--                :reduce="getVacanciesFromCustomer => getVacanciesFromCustomer.id"-->
<!--            >-->
<!--              <div slot="no-options">Voeg eerst een vacature toe voor het bedrijf.</div>-->
<!--            </v-select>-->
<!--          </div>-->
          <div class="form-group col-lg-3">
            <label for="candidatePlacement-candidate">Kandidaat</label>
            <input
                readonly
                name="name"
                id="candidatePlacement-candidate"
                type="text"
                class="form-control"
                v-model="candidateName"
            />
            <span v-if="errors.first('candidate')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label for="candidatePlacement-startDate">Begin datum</label>
            <datepicker
                :language="nl"
                id="startDate"
                v-model="candidatePlacement.startDate"
                :fullMonthName="true"
                format="dd-MM-yyyy"
                input-class="form-control"
                :calendar-button="true"
                :calendar-button-icon="'far fa-calendar-alt'"
                :clear-button="true"
                :clear-button-icon="'far fa-times'"
                :class="{ 'is-invalid': errors.has('date') }"
            ></datepicker>
            <input
                v-model="candidatePlacement.startDate"
                v-show="false"
                v-validate="'required'"
                name="date"
            />
            <span v-if="errors.first('date')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="col-lg-4 form-group">
            <label for="candidatePlacement-hourlyWage">Uurloon</label>
            <input
                v-validate="'required'"
                name="candidate-hourlyWage"
                id="candidatePlacement-hourlyWage"
                type="number"
                class="form-control"
                v-model="candidatePlacement.hourlyWage"
            />
            <span v-if="errors.first('candidate-hourlyWage')" class="small text-danger">Dit veld mag alleen cijfers en komma's bevatten.</span>
          </div>
<!--          <div class="col-lg-4">-->
<!--            <label>Pensioen</label>-->
<!--            <v-select :options="getStandardFormChoices('retirements')"-->
<!--                      v-model="candidatePlacement.retirement"-->
<!--                      label="name"-->
<!--                      :selectOnTab="true"-->
<!--            />-->
<!--          </div>-->
        </div>
        <div class="row candidate-bottom">
          <div class="form-group col-12">
            <label for="customer-defaultInstructions">Welkomst e-mail</label>
            <tiptap-editor
                v-model="candidatePlacement.firstDayInstructions"
                :content="candidatePlacement.firstDayInstructions"/>
          </div>

          <div class="col-xl-4 mb-3">
            <label for="">Geplaatst door</label>
            <v-select
                v-validate="'required'"
                :options="availableUsers"
                name="candidatePlacement-placedBy"
                id="candidatePlacement-placedBy"
                v-model="candidatePlacement.placedBy"
                label="displayName"
                :multiple="true"
                :selectable="() =>   candidatePlacement.placedBy.length < 2"
                :selectOnTab="true"
            >
              <span v-if="errors" class="small text-danger">Minimaal 1 persoon verplicht</span>
              <div slot="no-options">No users found</div>
            </v-select>
            <!--          this.candidate.placedBy =_.map(this.candidate.placedBy ,m=>{-->
            <!--          return {id:m.id, displayName:m.displayName}-->
            <!--          })-->
          </div>
          <div class="col-xl-4 mb-3" style="padding-top: 40px">
          </div>
          <div class="col-xl-4 mb-3" style="padding-top: 40px; text-align: right;">
            <input type="checkbox" id="flexworker-hourapp" v-model="createHourAppAccount" />
            <label for="flexworker-hourapp" style="margin-left: 5px">Create account in Hour APP</label>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="alert alert-danger">Kandidaat staat op blacklist. Hierdoor kan deze kandidaat niet geplaatst
          worden.
        </div>
      </template>
    </template>
    <div slot="portletFooter" class="col-12 text-right">
      <button v-if="isAdmin" @click="saveCandidatePlacement" type="submit" class="btn btn-primary" :disabled="!hasContract">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import Datepicker from "vuejs-datepicker";
import {nl} from "vuejs-datepicker/dist/locale";
import store from "@/store";
import Vue from "vue";
import { buildFlexworkerHourAppPayload, describeHourAppSyncOutcome } from "@/utils/placementSync";

export default {
  props: ["candidateId", "candidateInfo"],
  components: {
    Datepicker
  },
  data() {
    return {
      nl: nl,
      availableUsers: [],
      createHourAppAccount: false,
      renderedComponent: true,
      candidate: null,
      candidateName: null,
      candidatePlacementCopy: null,
      candidatePlacement: {
        customerId: '',
        vacancyId: null,
        candidate: null,
        startDate: null,
        hourlyWage: null,
        firstDayInstructions: null,
        retirement: null,
        placedBy: []
      }
    };
  },
  computed: {
    ...mapGetters("vacancies", [
      "getVacancies",
      "getVacanciesFromCustomer"
    ]),
    ...mapGetters("candidates", ["getCandidates", "getCandidate", "getAvailableCandidatesPerCustomer", "getStandardFormChoices"]),
    ...mapGetters("customers", ["getCustomer", "getCustomers", "getAvailableCustomersPerCandidate"]),
    ...mapGetters('blacklist', ['checkBlacklist']),
    ...mapGetters('pools', ['getPoolsOfCandidateId']),
    ...mapGetters('placements', ['getCandidatePlacements']),
    ...mapGetters('contracts', ['getcontracts']),
    isAdmin() {
      return this.$store.state.users.me.admin;
    },
    hasContract() {
      return this.getcontracts.some(c => c.candidateId === this.candidateId);
    },
    hasOpenPlacement() {
      const placements = this.getCandidatePlacements(this.candidateId);
      return placements.some(p => !p.endDate);
    }
  },
  methods: {
    customerChosen(customerId) {
      this.candidatePlacement.firstDayInstructions = this.getCustomer(customerId).defaultInstructions;
    },
    renderComponent() {
      this.renderedComponent = false;

      this.$nextTick(() => {
        this.renderedComponent = true;
      });
    },
    removeCandidateFromPool(customerId, candidateId) {
      const poolsOfCandidate = this.getPoolsOfCandidateId(candidateId);
      _.filter(poolsOfCandidate, {
        'customerId': customerId,
        'archived': false
      }).forEach(pool => {
        this.$store.dispatch('pools/patch', {
          id: pool.id,
          archived_at: new Date(),
          archived_by: this.$store.getters.getUserData,
          archived: true
        })
      });
    },
    async saveCandidatePlacement() {
      if (this.hasOpenPlacement) {
        const openPlacement = this.getCandidatePlacements(this.candidateId).find(p => !p.endDate);
        const customer = openPlacement ? this.getCustomer(openPlacement.customerId) : null;
        const customerName = customer ? customer.name : 'onbekend bedrijf';
        const confirmed = await this.$swal({
          title: 'Extra plaatsing aanmaken?',
          html: `Weet je zeker dat je een extra plaatsing wil aanmaken?<br>Deze medewerker is momenteel geplaatst bij <strong>${customerName}</strong>.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ja, aanmaken',
          cancelButtonText: 'Annuleren'
        });
        if (!confirmed.value) return;
      }
      if (this.candidatePlacement.vacancyId === null) {
        delete this.candidatePlacement.vacancyId
      }
      if (this.candidatePlacement.startDate) {
        this.candidatePlacement.startDate = moment(this.candidatePlacement.startDate).format("YYYY-MM-DD")
      }
      this.candidatePlacement.candidateId = this.candidateId
      delete this.candidatePlacement.candidate

      this.$validator.validate().then(result => {
        if (result) {
          this.candidatePlacement.candidateIsHolidayWorker = _.includes(this.candidate.shifts, "Vakantiekracht");
          this.candidatePlacementCopy = this.candidatePlacement;
          this.candidatePlacement.createdBy = this.$store.getters.getUserData
          this.candidatePlacement.department = this.$store.getters.getUserData.selectedDepartment
          this.$store.dispatch("placements/set", this.candidatePlacement).then(() => {
            this.removeCandidateFromPool(this.candidatePlacement.customerId, this.candidatePlacement.candidateId)
            this.$toasted.global.successRequest({
              message: "Plaatsing aangemaakt"
            });

            this.renderComponent();
            this.$emit("unsavedChanges", false);
            this.$emit('setCandidatePage', 'candidatePlacings');

            if(this.createHourAppAccount) {
                const payload = buildFlexworkerHourAppPayload({
                    candidatePlacement: this.candidatePlacement,
                    candidate: this.candidate,
                    candidateName: this.candidateName,
                    customer: this.getCustomer(this.candidatePlacement.customerId),
                });
                this.$store.dispatch('users/postUserHourApp', {ApiClient: Vue.prototype.$ApiClient, user: payload}).then((res) => {
                    const outcome = describeHourAppSyncOutcome(res);

                    if (!outcome.ok) {
                        this.$toasted.global.failedRequest({message: outcome.message});
                    }
                })
            }
          }).catch(error => {
            this.$toasted.global.failedRequest();
            console.log(error)
          });
        } else {
          this.$toasted.global.failedFormRequest();
        }
      });
    }
  },
  watch: {
    candidatePlacement: {
      handler: function (val) {
        this.$emit("unsavedChanges", JSON.stringify(val) !== JSON.stringify(this.candidatePlacementCopy));
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch('users/getAllUsers', {
      ApiClient: Vue.prototype.$ApiClient,
      departments: this.$store.getters.getUserData.departments
    }).then((res) => {
      if (res.status === 200) {
        this.availableUsers = _.map(res.data.users.filter(user => user.hasOwnProperty('email')), user => {
          console.log(user)
          return {
            displayName: user.firstname + ' ' + user.lastname,
            id: user.uid
          }
        });

        this.nextPageToken = res.nextToken;
      }
    }).catch((err) => {

    });
    this.candidateName = `${this.candidateInfo.firstName} ${this.candidateInfo.lastName}`;
    this.candidatePlacementCopy = JSON.parse(
        JSON.stringify(this.candidatePlacement)
    );
    this.candidate = this.getCandidate(this.candidateId)
  }
};
</script>

<style lang="scss" scoped>
.candidate-bottom {
    input[type="checkbox"],input[type="radio"] {
        accent-color: #146F70;
        vertical-align: middle;
        
    }
}
</style>